import { useState } from 'react';
import { BookOpen, ExternalLink, FileJson } from 'lucide-react';
import PageShell from '../components/PageShell';
import Tabs from '../components/Tabs';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api';
const SWAGGER_URL = `${API_BASE_URL}/docs`;
const REDOC_URL = `${API_BASE_URL}/redoc`;
const OPENAPI_URL = `${API_BASE_URL}/openapi.json`;

type TabId = 'swagger' | 'redoc';

function ApiDocs() {
  const [tab, setTab] = useState<TabId>('swagger');
  const url = tab === 'swagger' ? SWAGGER_URL : REDOC_URL;

  return (
    <PageShell
      title="API Docs"
      subtitle="Interactive OpenAPI documentation for the ZeroTail Accounting API."
    >
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Tabs
          tabs={[
            { id: 'swagger', label: 'Swagger UI' },
            { id: 'redoc', label: 'ReDoc' },
          ]}
          active={tab}
          onChange={(id) => setTab(id as TabId)}
        />
        <div className="flex flex-wrap gap-2">
          <a
            href={SWAGGER_URL}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1.5 rounded-lg border border-zt-border bg-zt-surface px-3 py-2 text-sm font-medium text-slate-200 hover:border-zt-primary hover:text-zt-primary"
          >
            <BookOpen size={16} /> Swagger <ExternalLink size={13} />
          </a>
          <a
            href={REDOC_URL}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1.5 rounded-lg border border-zt-border bg-zt-surface px-3 py-2 text-sm font-medium text-slate-200 hover:border-zt-primary hover:text-zt-primary"
          >
            <BookOpen size={16} /> ReDoc <ExternalLink size={13} />
          </a>
          <a
            href={OPENAPI_URL}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-1.5 rounded-lg border border-zt-border bg-zt-surface px-3 py-2 text-sm font-medium text-slate-200 hover:border-zt-primary hover:text-zt-primary"
          >
            <FileJson size={16} /> openapi.json <ExternalLink size={13} />
          </a>
        </div>
      </div>

      <div className="overflow-hidden rounded-xl border border-zt-border bg-white">
        <iframe
          key={tab}
          src={url}
          title={tab === 'swagger' ? 'Swagger UI' : 'ReDoc'}
          className="h-[calc(100vh-16rem)] w-full"
        />
      </div>
    </PageShell>
  );
}

export default ApiDocs;
